(function() {
  const revealElements = new Set();
  
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const target = entry.target;
        target.classList.add('reveal-visible');
        
        // Trigger staggered children
        const staggeredChildren = target.querySelectorAll('.reveal-stagger-item:not(.reveal-visible)');
        staggeredChildren.forEach((child, index) => {
          setTimeout(() => {
            child.classList.add('reveal-visible');
          }, index * 100);
        });

        revealObserver.unobserve(target);
        revealElements.delete(target);
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: '0px 0px 50px 0px' // Trigger slightly before it enters the viewport
  });

  const setupAnimations = () => {
    const elements = document.querySelectorAll('[class*="reveal-"]:not(.reveal-observed)');
    elements.forEach(el => {
      el.classList.add('reveal-observed');
      revealObserver.observe(el);
      revealElements.add(el);
    });
  };

  // Initial Run
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupAnimations);
  } else {
    setupAnimations();
  }

  // Mutation Observer for dynamic content
  const mutationObserver = new MutationObserver((mutations) => {
    let shouldUpdate = false;
    for (const mutation of mutations) {
      if (mutation.addedNodes.length > 0) {
        shouldUpdate = true;
        break;
      }
    }
    if (shouldUpdate) setupAnimations();
  });

  mutationObserver.observe(document.body, { childList: true, subtree: true });

  // Safety fallback: Reveal everything if it's still hidden after 3 seconds
  // This prevents the "missing elements" issue in case of observer failure
  window.addEventListener('load', () => {
    setTimeout(() => {
      document.querySelectorAll('[class*="reveal-"]:not(.reveal-visible)').forEach(el => {
        // Only reveal if it's actually in or near viewport, or just reveal all as fallback
        el.classList.add('reveal-visible');
      });
    }, 3000);
  });
})();
